"use strict";

freeLunchReport.classy.controller({
	name: "FreeLunchReportSideNavController",
	inject: ["$scope", "$state", 
		"ArchiveYearsService", "FreeLunchReportService", "DateService", "SchoolModelService"],
	init: function()
	{
		var parent = this;
		this.SchoolModelService.resolveData().then(function() {
			var archiveyears = parent.ArchiveYearsService.get();
			parent.$.years = [{"App_Fin_Year": parent.DateService.getCurrentYear()}];
			parent.$.years = parent.$.years.concat(archiveyears);
		});
        this.$.FreeLunchReportService = this.FreeLunchReportService;
	}
});
